export function formatJson(v: unknown): string {
  try {
    return JSON.stringify(v, null, 2);
  } catch {
    return String(v);
  }
}

export function formatCodeContent(content: unknown): string {
  if (typeof content !== "string") {
    try {
      return JSON.stringify(content, null, 2);
    } catch {
      return String(content);
    }
  }
  try {
    const trimmed = content.trim();
    const unescaped = trimmed
      .replace(/\\n/g, "\n")
      .replace(/\\"/g, '"')
      .replace(/^"|"$/g, "");
    const parsed = JSON.parse(unescaped);
    return JSON.stringify(parsed, null, 2);
  } catch {
    return content.replace(/\\n/g, "\n").replace(/\\"/g, '"').trim();
  }
}

export function dedupe<T>(arr: T[]): T[] {
  return Array.from(new Set(arr));
}

export function coerceLike(
  sample: unknown,
  raw: string
): string | number | boolean {
  if (typeof sample === "number") {
    const n = Number(raw);
    return Number.isFinite(n) ? n : (sample as number);
  }
  if (typeof sample === "boolean") {
    const lc = raw.trim().toLowerCase();
    if (lc === "true") return true;
    if (lc === "false") return false;
    return !!sample;
  }
  return raw;
}
